exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notification-panel .notification-panel-label[data-v-b1cf7fc2]{font-size:1.5rem;font-weight:600}.notification-panel .notification-panel-form-label[data-v-b1cf7fc2]{margin-bottom:.375rem;font-size:1rem;color:var(--fts-form-label)}.notification-panel .notification-panel-form-group[data-v-b1cf7fc2]{margin-bottom:2rem}", ""]);

// exports
